import {
  ASCII_END,
  ASCII_START,
  FULL_WIDTH_OFFSET,
  FULL_WIDTH_SPACE,
  HALF_WIDTH_SPACE,
  KANA_MAP,
} from './const'

export const insertCommaEveryThreeDigits = (str: string) => {
  return str.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const replaceCommaAndHalfWithDigitToEmpty = (str: string) => {
  return str.replace(/[,\d]/g, '')
}

export const replaceCommaToEmpty = (str: string) => {
  return str.replace(/,/g, '')
}

export const replaceSpaceToEmpty = (str: string) => {
  return str.replace(/\s+/g, '')
}

export const replaceNotDigitToEmpty = (str: string) => {
  return str.replace(/[^\d]/g, '')
}

export const replaceStartZeroAndNotDigitToEmpty = (str: string) => {
  return str.replace(/^0+|[^\d]/g, '')
}

export function createAddress(
  results: { address1: string; address2: string; address3: string }[]
): string {
  // Considering duplications of areas for same ZIP code (postal code)
  // cf. https://yubin.ko2.info/duplicate.html
  return (['address1', 'address2', 'address3'] as const)
    .flatMap((key) => {
      const addressSet = new Set(results.map((v) => v[key]))
      return addressSet.size === 1 ? results[0][key] : []
    })
    .join('')
}

export function toFullWidthKana(str: string): string {
  const reg = new RegExp('(' + Object.keys(KANA_MAP).join('|') + ')', 'g')
  return str
    .replace(reg, (match) => {
      const newKey = match as keyof typeof KANA_MAP
      return KANA_MAP[newKey]
    })
    .replace(/ﾞ/g, '゛')
    .replace(/ﾟ/g, '゜')
}

export function toFullWidthAlphanumeric(str: string) {
  return str.replace(/[A-Za-z0-9]/g, (s) => {
    return String.fromCharCode(s.charCodeAt(0) + FULL_WIDTH_OFFSET)
  })
}

export function toFullWidthSpecialChars(str: string) {
  return str
    .split('')
    .map((char) => {
      const code = char.charCodeAt(0)
      if (code === HALF_WIDTH_SPACE)
        return String.fromCharCode(FULL_WIDTH_SPACE)
      if (ASCII_START <= code && code <= ASCII_END) {
        return String.fromCharCode(code + FULL_WIDTH_OFFSET)
      }

      return char
    })
    .join('')
}

export function convertCentisToMillis(centis: number) {
  return 10 * centis
}

export function convertMillisToCentis(millis: number) {
  return millis / 10
}
